export function getFileURL(id, version = 1) {
  switch (version) {
    case 1:
      return getFileURLV1(id);

    case 2:
      return getFileURLV2(id);

    default:
      throw new Error(`GetFileURL for version ${version} is not yet implemented.`);
  }
}

function getFileURLV1(id) {
  return `${location.origin}/api/v1/upload/${id}`;
}

function getFileURLV2(id) {
  let fileURI = id;

  if (!fileURI) {
    return '';
  }

  if (!fileURI.startsWith('/')) {
    fileURI = `/${fileURI}`;
  }

  return id ? `${location.origin}/api/v1/upload/v2${fileURI}` : '';
}
